import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=7c745915&scoped=true&"
import script from "./assign.vue?vue&type=script&lang=js&"
export * from "./assign.vue?vue&type=script&lang=js&"
import style0 from "./assign.vue?vue&type=style&index=0&id=7c745915&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c745915",
  null
  
)

export default component.exports